import { gql, TypedDocumentNode } from "@apollo/client";

export interface EventObjectHeadingQueryResponse {
  event: {
    id: string;
    title: string;
    status: string;
    eventCode?: string | null;
    startsAt: string;
    endsAt: string;
    timezone: string;
    facility?: { id: string; name: string } | null;
  };
}

export const EVENT_OBJECT_HEADING_QUERY: TypedDocumentNode<EventObjectHeadingQueryResponse, { slug: string }> = gql`
  query EventObjectHeading($slug: String!) {
    event(slug: $slug) {
      id
      title
      status
      eventCode
      startsAt
      endsAt
      timezone
      facility {
        id
        name
      }
    }
  }
`;
